import React, { useState, useEffect } from 'react';
import axios from '../config/axiosConfig'; 
import './TestimonialsSlider.css';
import { FaQuoteLeft, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const TestimonialsSlider = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await axios.get('https://hsn.urugowoc.org.rw/backend/api/testimonials');
      setTestimonials(response.data);
    } catch (error) {
      console.error('Error fetching testimonials:', error);
    } finally {
      setLoading(false);
    }
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  if (loading) return <div className="loading">Loading testimonials...</div>;
  if (testimonials.length === 0) return null;

  const currentTestimonial = testimonials[currentIndex];

  return (
    <div className="testimonials-slider">
      <div className="testimonial-content">
        <FaQuoteLeft className="quote-icon" />
        <p className="testimonial-text">{currentTestimonial.content}</p>
        
        <div className="rating">
          {[...Array(5)].map((_, i) => (
            <FaStar 
              key={i} 
              className={i < currentTestimonial.rating ? 'star-filled' : 'star-empty'}
            />
          ))}
        </div>
        
        <div className="testimonial-author">
          <div className="author-info">
            <h4>Happy Employer</h4>
            <p>Business Owner</p>
          </div>
        </div>
      </div>

      <div className="slider-controls">
        <button onClick={prevSlide} className="slider-btn">
          <FaChevronLeft />
        </button>
        
        <div className="slider-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`slider-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
        
        <button onClick={nextSlide} className="slider-btn">
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
};

export default TestimonialsSlider;